<template>
  <div :key="$route.params.objectid">
    <cbs-object
      v-if="objectFull"
      :objectid="objectid"
      :object-full="objectFull"
    />
    <!-- BUG-781: объект не отдан (нет права или его нет) — раньше пустая страница без слова. -->
    <b-card
      v-else-if="loadError"
      class="cbs-object-denied"
    >
      <h4>Нет доступа</h4>
      <p class="mb-0">
        {{ loadError }}
      </p>
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import CbsObject from '@/cubus/components/object/CbsObject.vue'
import useCubus from '@/cubus/services/useCubus'

export default {
  components: {
    BCard,
    CbsObject,
  },
  props: {},
  data() {
    return {
      // BUG-387: в адресе может стоять КАК числовой id, так и sid объекта. Раньше параметр
      // безусловно приводился к числу, и `Number('scenario')` давал `NaN`: запрос уходил без
      // ключа, сервер отвечал «No object key found», а человек видел красное окно с кодом
      // вместо страницы. Ссылку с sid пишет и агент (`PROP-386`), и человек руками — sid
      // устойчив между доменами, а id у каждого домена свой.
      routeKey: String(this.$route.params.objectid || ''),
      objectid: null,
      objectFull: null,
      loadError: null,
    }
  },
  computed: {
    /** Чем спрашивать объект: цифры — это id, всё остальное — sid. */
    objectKey() {
      return /^\d+$/.test(this.routeKey)
        ? { objectid: Number(this.routeKey) }
        : { objectsid: this.routeKey }
    },
  },
  created() {
    useCubus.setPageTitle(`Object ${this.routeKey}`)
    this.init()
  },
  methods: {
    init() {
      this.initObject()
    },
    async initObject() {
      if (!this.routeKey) return
      this.loadError = null
      const { objectfull, error } = await useCubus.loadObjectOrError(this.objectKey)
      this.objectFull = objectfull || null
      if (!this.objectFull) this.loadError = error || 'Объект не найден.'
      if (this.objectFull && this.objectFull.object) {
        // Дочернему компоненту нужен ЧИСЛОВОЙ id — при заходе по sid он известен только
        // после загрузки.
        this.objectid = this.objectFull.object.id
        if (this.objectFull.object.name) useCubus.setPageTitle(this.objectFull.object.name)
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    // Обновляем данные при изменении параметра маршрута
    this.objectFull = null
    this.loadError = null
    this.objectid = null
    this.routeKey = String(to.params.objectid || '')
    this.init()
    // this.fetchUserData(this.userId);
    next() // Продолжить навигацию
  },
}
</script>

<style scoped>

</style>
